import { computed, reactive, unref } from 'vue';
import ContactAPI from 'dashboard/api/contacts';

// The group behind a contact is fetched once and shared across the dashboard:
// the contact sidebar shows its description and members, and the message list
// needs the participants to put a name on the people mentioned in a message.
const groups = reactive(new Map());
const inFlight = new Set();

export const isWhatsappGroupContact = contact =>
  String(contact?.identifier || '').endsWith('@g.us');

export const fetchWhatsappGroup = async contactId => {
  if (!contactId || groups.has(contactId) || inFlight.has(contactId)) return;

  inFlight.add(contactId);
  try {
    const { data } = await ContactAPI.getWhatsappGroup(contactId);
    groups.set(contactId, data.payload || null);
  } catch (error) {
    // Whatever an earlier sync stored on the contact still shows.
    groups.set(contactId, null);
  } finally {
    inFlight.delete(contactId);
  }
};

export const useWhatsappGroup = contactId =>
  computed(() => groups.get(unref(contactId)) || null);
